<template>
  <div
    class="navigation-bar"
    :class="{
      'navigation-bar-hidden': isChatTabActive
    }"
  >
    <div
      class="navigation-bar-tab"
      :class="{
        'tab-selected': isActiveTab(TAB_MAP.HOME)
      }"
      @click="handleTabClick(TAB_MAP.HOME)"
      :style="isActiveTab(TAB_MAP.HOME) ? { borderTopColor: widgetColor, color: widgetColor } : { borderTopColor: inActiveTabBorderColor }"
    >
      <a 
        v-if="isActiveTab(TAB_MAP.HOME)"
      >
        <HomeTabActiveLogo/>
      </a>
      <img v-else src="../assets/images/home-tab.svg" alt="Home tab"/>
      Home
    </div>
    <div
      class="navigation-bar-tab"
      :class="{
        'tab-selected': isActiveTab(TAB_MAP.CHAT)
      }"
      @click="handleTabClick(TAB_MAP.CHAT)"
      :style="isActiveTab(TAB_MAP.CHAT) ? { borderTopColor: widgetColor, color: widgetColor } : { borderTopColor: inActiveTabBorderColor }"
    >
      <a 
        v-if="isActiveTab(TAB_MAP.CHAT)"
      >
        <ChatTabActiveLogo/>
      </a>
      <img v-else src="../assets/images/chat-tab.svg" alt="Chat tab"/>
      Chat
    </div>
    <div
      class="navigation-bar-tab"
      :class="{
        'tab-selected': isActiveTab(TAB_MAP.HELP)
      }"
      @click="handleTabClick(TAB_MAP.HELP)"
      :style="isActiveTab(TAB_MAP.HELP) ? { borderTopColor: widgetColor, color: widgetColor } : { borderTopColor: inActiveTabBorderColor }"
    >
      <a 
        v-if="isActiveTab(TAB_MAP.HELP)"
      >
        <HelpTabActiveLogo/>
      </a>
      <img v-else src="../assets/images/help-tab.svg" alt="Help tab"/>
      Help
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { sendGainSightEvent, SURFACE_KB_IN_CHAT_GS_EVENTS } from '../../gainSightIntegration';
import HomeTabActiveLogo from '../assets/images/home-tab-active.svg?inline';
import ChatTabActiveLogo from '../assets/images/chat-tab-active.svg?inline';
import HelpTabActiveLogo from '../assets/images/help-tab-active.svg?inline';
import { CONVERSATION_STATUS_TYPES } from '../../shared/constants/conversation';
import { TAB_TYPE } from '../helpers/constants';

export default {
  name: 'NavigationBar',
  components: {
    HomeTabActiveLogo,
    ChatTabActiveLogo,
    HelpTabActiveLogo,
  },
  props: {
    chatTabProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      TAB_MAP: {
        HOME: 0,
        CHAT: 1,
        HELP: 2
      },
      TAB_ROUTE_MAP: {
        0: '/home',
        1: '/chat',
        2: '/help'
      },
      selectedTab: 0,
      inActiveTabBorderColor: '#d6dde8',
    };
  },
  watch: {
    $route(to) {
      this.updateSelectedTab(to);
    },
    conversationAttributes: {
      handler(newVal) {
        if(newVal?.status === CONVERSATION_STATUS_TYPES.OPEN || newVal?.status === CONVERSATION_STATUS_TYPES.PENDING) {
          this.openDefaultChatTab();
        }
      },
      deep: true,
    },
    selectedTab(tab) {
      localStorage.setItem('presentTab', this.TAB_ROUTE_MAP[tab].substring(1))
    }
  },
  computed: {
    ...mapGetters({
      webChannelConfig: 'appConfig/getWebChannelConfig',
      widgetColor: 'appConfig/getWidgetColor',
      conversationAttributes: 'conversationAttributes/getConversationParams',
    }),
    isChatTabActive() {
      return this.$route.name === 'Chat';
    },
  },
  methods: {
    ...mapActions('kbDetails', ['fetchKbDetails']),
    handleTabClick(tab) {
      const tabName = this.TAB_ROUTE_MAP[tab].substring(1);
      this.selectedTab = tab;
      sendGainSightEvent(SURFACE_KB_IN_CHAT_GS_EVENTS.WIDGET_TAB_CLICKED, {tabName});
      const route = {
        path: this.TAB_ROUTE_MAP[tab],
        query: {
          ...this.chatTabProps,
        }
      };
      if (tab === this.TAB_MAP.CHAT) {
        window.bus.$emit('chat-tab-clicked');
        return;
      }
      this.$router.push(route);
    },
    updateSelectedTab(route) {
      const tab = Object.keys(this.TAB_ROUTE_MAP).find(
        key => this.TAB_ROUTE_MAP[key] === route.path
      );
      if (tab !== undefined) {
        this.selectedTab = Number(tab);
      }
    },
    isActiveTab(tab) {
      return this.selectedTab === tab;
    },
    openDefaultChatTab() {
      const tab = localStorage.getItem('presentTab');
      if(tab === TAB_TYPE.CHAT) {
        this.handleTabClick(1);
      }
    }
  },
  mounted() {
    const { websiteToken } = this.webChannelConfig;
    this.fetchKbDetails(websiteToken);
    window.bus.$on('switch-to-help-tab', () => {
      this.handleTabClick(2);
    })
  }
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/_navigationBar.scss';
</style>